'use strict'

const some_ = require('lodash/some')
const values_ = require('lodash/values')
const omit_ = require('lodash/omit')
const get_ = require('lodash/get')
const isEmpty_ = require('lodash/isEmpty')
const isInputComponent = require('dbsm-common/src/isInputComponent')
const {
  UploadButton: uploadButtonSdkType
} = require('dbsm-common/src/componentTypes')

const isUploadButtonValid = (component, record, connectionConfig) => {
  if (component.validity.valid) {
    return true
  }

  const hasErrorOtherThanValueMissing = some_(
    values_(omit_(component.validity, ['valid', 'valueMissing'])),
    value => value
  )
  if (hasErrorOtherThanValueMissing) {
    return false
  }

  const fieldConnectedToValue = get_(
    connectionConfig,
    'properties.value.fieldName'
  )

  return !isEmpty_(record[fieldConnectedToValue])
}

module.exports = ({ component, connectionConfig }, currentRecord) => {
  if (!isInputComponent(component)) {
    return true
  }

  if (component.type !== uploadButtonSdkType) {
    return component.validity.valid
  }

  return isUploadButtonValid(component, currentRecord, connectionConfig)
}



// WEBPACK FOOTER //
// ./helpers/isComponentValid.js